import { Component, OnInit } from '@angular/core';
import { GlobalsService } from '../common/services/globals.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  get TCLink() {
    if (GlobalsService.language == null || GlobalsService.language == '' || GlobalsService.language == 'EN') {
      return "../../../billing/paynow/assets/ePAY_T&C.pdf";
    } else if(GlobalsService.language == 'ES') {
       if(GlobalsService.partner === 'AHNJ') {
        return "../../../billing/paynow/assets/ES_ePAY_T&C.pdf";
      }
    }
  }
  constructor(private _global: GlobalsService) { }

  get partner(){
    return GlobalsService.partner;
  }

  ngOnInit() {

  }

}
